/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useEffect, useState, useRef } from 'react'
import Script from 'react-load-script'
import styles from './player.styles'

const Player = (props) => {

  const [scriptLoaded, setScriptLoaded] = useState()
  const [scriptNeeded, setScriptNeeded] = useState();
  const playerRef = useRef();

  const doEmbed = () => {
    // eslint-disable-next-line no-undef
    kWidget.embed({
      "targetId": props.id,
      "wid": `_${process.env.GATSBY_STREAMAMG_PARTNER_ID}`,
      "uiconf_id": process.env.GATSBY_STREAMAMG_UICONF,
      "flashvars": {
        "streamerType": "auto",
        "ks" : props.ksession
      },
      "entry_id": props.id
    });
  }

  useEffect(() => {
    try {
      doEmbed();
    } catch (error) {
      setScriptNeeded(true)
    }
  }, [])

  return (
    <div>
      <div id={props.id} ref={playerRef} sx={styles.container} />
      {scriptNeeded && !scriptLoaded &&
        <Script
          url={`https://open.http.mp.streamamg.com/p/${process.env.GATSBY_STREAMAMG_PARTNER_ID}/sp/${process.env.GATSBY_STREAMAMG_PARTNER_ID}00/embedIframeJs/uiconf_id/${process.env.GATSBY_STREAMAMG_UICONF}>/partner_id/${process.env.GATSBY_STREAMAMG_PARTNER_ID}`}
          onLoad={() => {
            doEmbed();
            setScriptLoaded(true)
          }}
        />
      }
    </div>
  )
}

export default Player
